import { InjectionToken } from '@angular/core';

export type ValidationMessages = Record<string, Record<string, string>>;

export const CORE_VALIDATION_MESSAGES = new InjectionToken<ValidationMessages>(
  'Default validation message record shared across application'
);

export const ADDITIONAL_VALIDATION_MESSAGES =
  new InjectionToken<ValidationMessages>(
    'Supplementary validation messages meant to be imported and merged with default validation messages'
  );
